interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
}

export default function SectionHeading({
  title,
  subtitle,
  action,
}: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6 md:mb-8">
      <div className="flex items-start gap-3">
        <span className="w-1 h-8 md:h-9 rounded-full bg-accent-500 shrink-0 mt-0.5"></span>
        <div>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-950 tracking-wide">
            {title}
          </h2>
          {subtitle && (
            <p className="text-sm text-foreground-500 mt-1 font-body">{subtitle}</p>
          )}
        </div>
      </div>
      {action}
    </div>
  );
}